import { Component, OnInit } from '@angular/core';

import { CalendarService } from '../services/calendar-service/calendar.service';
import { CalendarListEntry } from '../interfaces/calendar';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'mcrit-gestio-calendars',
  templateUrl: 'calendars.component.html',
  styleUrls: ['calendars.component.css']
})
export class CalendarsComponent implements OnInit {
  public availableCalendars: Array<CalendarListEntry>;
  private unsubscriber : Subject<void> = new Subject<void>();

  public calendarChange($event) {
    let observable;
    switch ($event.type) {
      case 'subscription':
        this.calendarService.changeSubscription({
          id: $event.id,
          type: $event.channel,
          status: $event.status
        });
        break;
      case 'definition':
        break;
    }
    if (observable) {
      observable.subscribe(
        () => {
          console.log('Ok');
        },
        err => {
          console.log(err);
        }
      );
    }
  }

  constructor(private calendarService: CalendarService) { }

  ngOnInit() {
    this.calendarService.list().subscribe(
      calendarResponse => {
        this.availableCalendars = calendarResponse.items;
      },
      err => {
        console.log(err);
    });

    history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });

  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }


}
